export default "__VITE_ASSET__CMxaSTH2__"